import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/outdoorPro/shell/shell.service';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'curriculum',
      loadChildren: () => import('@lib/curriculum/curriculum.module').then((m) => m.CurriculumModule),
      runGuardsAndResolvers: 'always',
    },
    {
      path: 'docs',
      loadChildren: () => import('@lib/docs/docs.module').then((m) => m.DocsModule),
    },
    {
      path: 'assessments/:licenceId',
      loadChildren: () => import('./assessments/assessments.module').then((m) => m.AssessmentsModule),
    },
    {
      path: 'lessons',
      loadChildren: () => import('./lessons/lessons.module').then((m) => m.LessonsModule),
    },
  ]),
  {
    path: 'problem-with-the-service',
    loadChildren: () =>
      import('@lib/problem-with-the-service/problem-with-the-service.module').then(
        (m) => m.ProblemWithTheServiceModule,
      ),
  },
  {
    path: 'page-not-found',
    loadChildren: () => import('@lib/page-not-found/page-not-found.module').then((m) => m.PageNotFoundModule),
  },
  {
    path: 'no-licence',
    loadChildren: () => import('@lib/no-app-access/no-app-access.module').then((m) => m.NoAppAccessModule),
  },
  // Fallback when no prior route is matched
  { path: '', redirectTo: 'tabs/home', pathMatch: 'full' },
  { path: '**', redirectTo: 'page-not-found', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
